const placeListsLayout = {
  notificationTypes: {
    gameFavoriteNotifications: 'GameFavoriteNotifications',
    gameCloseNotifications: 'GameCloseNotifications'
  },
  sortsNeedRealtimeUpdate: {
    myFavorite: 'MyFavorite',
    myRecent: 'MyRecent'
  },
  pageTypes: {
    home: 'Home',
    gameDetail: 'GameDetail'
  },
  maxNumOfGamesPerList: 6,
  seeAllLinkLabel: 'Action.SeeAll',
  NoGamesLabel: 'Label.NoGames',
  seeAllClass: 'see-all-button games-filter-changer btn-secondary-xs btn-more see-all-link-icon',
  deviceTypes: {
    computer: 'Computer'
  }
};

export default placeListsLayout;
